import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { CONTACT, CTA } from "../../data/site";
import { Reveal } from "./Reveal";
import { EnquiryForm } from "./EnquiryForm";

export const CTABand = ({ product }) => (
  <section id="enquiry" className="bg-[#0B162C] border-t hairline">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32 grid grid-cols-1 lg:grid-cols-2 gap-16">
      <Reveal>
        <p className="overline-x mb-6">{CTA.overline}</p>
        <h2 className="font-display tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-white" style={{ fontWeight: 800 }}>
          {CTA.headingLines.map((l, i) => <span key={i} className="block">{l}</span>)}
        </h2>
        <p className="text-white/55 leading-relaxed mt-8 max-w-md">{CTA.text}</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <a href={CONTACT.phoneHref} data-testid="cta-phone-button" className="btn-ghost">
            <Phone size={14} /> {CONTACT.phone}
          </a>
          <Link to="/showroom/" data-testid="cta-showroom-link" className="btn-ghost">
            {CTA.showroomLabel} <ArrowRight size={14} />
          </Link>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <EnquiryForm defaultProduct={product} />
      </Reveal>
    </div>
  </section>
);
